// Bookings page styles - Uses theme.palette.primary.main instead of hardcoded purple
import { alpha } from "@mui/material/styles";

export const getColors = (theme) => ({
  // Primary colors from theme
  primary: theme.palette.primary.main,
  primaryDark: theme.palette.primary.dark,
  primaryLight: theme.palette.primary.light,
  // Use MUI's alpha function for proper transparency
  primaryAlpha: (opacity) => alpha(theme.palette.primary.main, parseFloat(opacity) / 100),

  // Status colors
  success: "#10B981",
  successLight: "#ECFDF5",
  warning: "#F59E0B",
  warningLight: "#FFFBEB",
  danger: "#EF4444",
  dangerLight: "#FEF2F2",
  info: "#3B82F6",
  infoLight: "#EFF6FF",

  // Backgrounds
  bgPrimary: "#F8FAFC",
  bgCard: "#FFFFFF",
  bgHover: "#F1F5F9",

  // Text
  textPrimary: "#0F172A",
  textSecondary: "#64748B",
  textMuted: "#94A3B8",

  // Borders
  border: "#E2E8F0",
  borderLight: "#F1F5F9",

  // Chart colors
  chartPrimary: theme.palette.primary.main,
  chartPrimaryLight: theme.palette.primary.light,
  chartGreen: "#10B981",
  chartOrange: "#F59E0B",
  chartBlue: "#3B82F6",
  chartPurple: "#8B5CF6",
  chartCyan: "#06B6D4",
});

export const shadows = {
  card: "0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.06)",
  cardHover: "0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)",
  dropdown: "0 10px 40px rgba(0, 0, 0, 0.15)",
};

export const getBookingStatusStyle = (status, theme) => {
  const primaryColor = theme?.palette?.primary?.main || "#6D28D9";
  const primaryAlpha = alpha(primaryColor, 0.1);

  const statusMap = {
    scheduled: { color: "#3B82F6", bg: "#EFF6FF", label: "SCHEDULED" },
    confirmed: { color: primaryColor, bg: primaryAlpha, label: "CONFIRMED" },
    ongoing: { color: "#8B5CF6", bg: "#F5F3FF", label: "ONGOING" },
    completed: { color: "#10B981", bg: "#ECFDF5", label: "COMPLETED" },
    cancelled: { color: "#EF4444", bg: "#FEF2F2", label: "CANCELLED" },
    // Legacy status mappings
    pending: { color: "#F59E0B", bg: "#FFFBEB", label: "PENDING" },
    "no-show": { color: "#EF4444", bg: "#FEF2F2", label: "NO-SHOW" },
    noshow: { color: "#EF4444", bg: "#FEF2F2", label: "NO-SHOW" },
  };

  return statusMap[status?.toLowerCase()] || { color: "#64748B", bg: "#F8FAFC", label: status };
};

export const getServiceStyle = (service) => {
  const serviceMap = {
    skin: { color: "#3B82F6", bg: "#EFF6FF", label: "Skin Care" },
    dental: { color: "#8B5CF6", bg: "#F5F3FF", label: "Dental" },
    hair: { color: "#10B981", bg: "#ECFDF5", label: "Hair Care" },
    wellness: { color: "#F59E0B", bg: "#FFFBEB", label: "Wellness" },
    "financial strategy": { color: "#3B82F6", bg: "#EFF6FF", label: "Financial Strategy" },
    "wealth management": { color: "#8B5CF6", bg: "#F5F3FF", label: "Wealth Management" },
    "portfolio review": { color: "#10B981", bg: "#ECFDF5", label: "Portfolio Review" },
    "investment audit": { color: "#F59E0B", bg: "#FFFBEB", label: "Investment Audit" },
  };

  return serviceMap[service?.toLowerCase()] || { color: "#64748B", bg: "#F8FAFC", label: service };
};
